(function () {
    "use strict";

    angular.module("app").controller("SearchCompletedAssistanceInRequestsController", SearchCompletedAssistanceInRequestsController);

    SearchCompletedAssistanceInRequestsController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "securityCheck", "assistanceInService", "PersonCheckDialogContext",];
    function SearchCompletedAssistanceInRequestsController(controllerDecorator, infiniteScrollDataSourceFactory, securityCheck, assistanceInService, PersonCheckDialogContext) {
        
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "dialog"]);

        vm.toggleDetail = toggleDetail;

        vm.onSelectAll = onSelectAll;
        vm.selectedItems = [];
        vm.confirmSelection = confirmSelection;
        vm.modifyResult = modifyResult;
        vm.assistanceInResultCodes = assistanceInService.assistanceInResultCodes;

        initialize();

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(
                securityCheck.GetRequestsToConfirm,
                vm.SetLoadingState,
                items => {
                    items.forEach(assistanceInService.addForeignPartnerInfo);
                }
            );
            vm.DataSource.ResetSearch();
        }

        function confirmSelection() {
            vm.SetLoadingState(true);
            assistanceInService.confirmResults(
                vm.selectedItems,
                authenticateBeforeSigning,
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function onSelectAll(newState) {
            if (newState)
                vm.selectedItems = vm.DataSource.Items().map(request => request.PublicId);
            else
                vm.selectedItems = [];
        }

        function authenticateBeforeSigning() {
            const options = {
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("GetFasRedirectionTitle"),
                templateUrl: vm.Settings.applicationPath + "Account/ChangeFASLogin?returnurl=" + encodeURIComponent(vm.Navigator.CurrentPage)
            };
            vm.Dialog.Custom(options);
        }

        function modifyResult(person) {
            const originalResult = person.SecurityCheckResult;
            person.SecurityCheckResult = 0;

            PersonCheckDialogContext.openDialog(person).then(onSubmit, onCancel);
            function onSubmit(handledPerson) {
                
                securityCheck.SaveSecurityCheckResult(
                    { AssistanceInRequestPersonId: person.PublicId, Result: handledPerson.SecurityCheckResult, },
                    () => {
                        vm.DataSource.ResetSearch();
                    },
                    vm.ShowError,
                    angular.noop
                );
            }

            function onCancel() {
                person.SecurityCheckResult = originalResult;
            }
        }

        function toggleDetail(request) {
            if (vm.openRequest === request)
                vm.openRequest = null;
            else
                vm.openRequest = request;
        }
    }
})();
